import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Button, Grid, Box, Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as HeartLogo } from '../../images/Logo-Rebekah.svg';

const ContactMessage = () => {
  // const {navigation} = props;
  // const dispatch = useDispatch();
  // const [active, setActive] = useState(true);
  let navigate = useNavigate();

  return (
    <Grid container component="main" sx={styles.containerStyle}>
      <CssBaseline />
      <Grid item xs={12} md={12} lg={12} sx={styles.contentStyle}>
        <Box sx={styles.formCardContainerStyle}>
          <Stack direction="row" spacing="8px" sx={styles.formCardTitleStyle}>
            <HeartLogo fontSize={50} />
            <Typography variant="h5">Contact us!</Typography>
          </Stack>
          <Typography style={{ fontSize: 20, textAlign: 'center' }}>
            Toll Free number: +1-844-354-2160
          </Typography>
          <Typography style={{ fontSize: 20, textAlign: 'center' }}>
            Local number: +1-617-919-6185
          </Typography>
          <Typography style={{ fontSize: 20, textAlign: 'center' }}>
            Email: Heart@childrens.harvard.edu
          </Typography>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              sx={styles.formCardButtonStyle}
              onClick={() => navigate('/sop2web/home')}>
              Got it!
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

const styles = {
  containerStyle: {
    height: '93vh',
    backgroundColor: '#EDF3FC'
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // minWidth: 600,
    border: 0,
    my: 8
  },
  formCardContainerStyle: {
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 450,
    padding: 4,
    background: '#FFFF'
  },
  formCardButtonStyle: {
    mt: 4,
    mb: 5,
    flex: 1,
    width: 350
  },
  formCardTitleStyle: {
    my: 4,
    mx: 4,
    alignItems: 'center',
    justifyContent: 'center'
  }
};
export default ContactMessage;
